import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { Paper, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Button, ButtonGrey } from "../../../style/Button";
import { ModalButton } from "../../../style/ModalButton";
import TitlDollar from "../../../assets/dollar.png";
import DollarGrey from "../../../assets/dollargrey.png";
import { Image2 } from "../../../style/Logo";
import "./select.css";
import medImg from "../../../../src/assets/pharmcy/Copay Medizen.jpg";
import priImg from "../../../../src/assets/pharmcy/Copay Primera.png";
function getModalStyle() {
  const top = 50;
  const left = 45;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 600,
    height: 700,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #808080",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: 0,
    overflow: "auto",
  },
  heading: {
    color: "#0389fb",
    fontSize: 15,
    fontFamily: "Arial",
    display: "flex",
    paddingBottom: 10,
    paddingLeft: 10,
  },
  sample: {
    backgroundColor: "#03b3fb",
    fontSize: 10,
    fontWeight: "Bold",
    paddingTop: 0,
    margin: 10,
    height: 20,
    padding: "0px",
    width: "180px",
    color: "white",
    borderRadius: 20,
    "&:hover": {
      backgroundColor: "#0389fb",
      color: "white",
    },
  },
  column: {
    marginLeft: 25,
    borderBottom: "0.5px solid #808080",
  },
  box1: {
    display: "block",
    float: "right",
    textAlign: "center",
    marginBottom: 10,
    height: 50,
    borderRight: "none",
    border: ".5px solid #808080",
    borderRadius: 0,
    width: 145,
    boxShadow: "none",
  },
  box2: {
    display: "block",
    float: "right",
    textAlign: "center",
    marginBottom: 10,
    height: 60,
    marginTop: -5,
    border: ".5px solid #808080",
    borderRadius: 0,
    width: 155,
    backgroundColor: "#666666",
    boxShadow: "none",
  },
  box3: {
    display: "block",
    float: "right",
    marginBottom: 10,
    height: 50,
    borderLeft: "none",
    border: ".5px solid #808080",
    borderRadius: 0,
    width: 165,
    boxShadow: "none",
  },

  Button1: {
    fontWeight: "600",
    fontFamily: "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
    textAlign: "center",
    backgroundColor: "#f2f2f2",
    borderRadius: 25,
    width: 120,
    textTransform: "none",
    Display: "Block",
    float: "right",
    height: 30,
    fontSize: 10,
    marginTop: -15,
    margin: 6,
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#03b3fb",
      color: "white",
    },
  },
  Button2: {
    fontWeight: "600",
    fontFamily: "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
    textAlign: "center",
    backgroundColor: "#03b3fb",
    borderRadius: 25,
    color: "White",
    width: 100,
    Display: "Block",
    float: "right",
    textTransform: "none",
    height: 30,
    fontSize: 10,
    marginTop: -15,
    marginRight: 20,
    margin: 6,
    "&:hover": {
      backgroundColor: "#0389fb",
      color: "white",
    },
  },
}));

export default function Medication({ parentCallback }) {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);

  const [rowsState] = React.useState([]);
  let [medarrayState] = React.useState([]);
  const [constructorHasRun, setConstructorHasRun] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseParentInfo = () => {
    setOpen(false);
    parentCallback("Popup");
  };

  const restoreRows = () => {
    if (constructorHasRun) return;
    let rowstring = window.sessionStorage.getItem("medarray");
    if (rowstring) {
      medarrayState = JSON.parse(rowstring);
    }
    if (medarrayState.length > 0) {
      medarrayState.forEach((element) => {
        createRows(element);
      });
    }
    setConstructorHasRun(true);
  };

  const createRows = (valuem) => {
    let discount;
    if (valuem.discount) {
      discount = (
        <React.Fragment>
          <Image2 src={TitlDollar} alt="logo" />{" "}
          <span style={{ fontWeight: 500, marginTop: "-4px", color: "green" }}>
            Coupon/Guide Available
          </span>
        </React.Fragment>
      );
    } else {
      discount = (
        <React.Fragment>
          <Image2 src={DollarGrey} alt="logo" />{" "}
          <span style={{ fontWeight: 500, marginTop: "-4px", color: "grey" }}>
            NA
          </span>
        </React.Fragment>
      );
    }
    let imageValue;
    if (valuem.medicationName === "Medizen") {
      imageValue = <img src={medImg} style={{ width: "100%" }} />;
    } else if (valuem.medicationName === "Primera") {
      imageValue = <img src={priImg} style={{ width: "100%" }} />;
    }
    rowsState.push(
      <React.Fragment>
        <Grid
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: -20,
            paddingBottom: 15,
          }}
        >
          <Grid item xs={4}>
            <Typography
              style={{
                padding: 7,
                fontSize: 10,
                fontWeight: "bold",
                paddingTop: 20,
              }}
            >
              Prescriptions Sent
              <br />
              <span
                style={{
                  fontWeight: 500,
                  marginTop: 5,
                  color: "#4678ED",
                }}
              >
                {valuem.medicationName}
              </span>
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography
              style={{
                padding: 7,
                fontSize: 10,
                fontWeight: "bold",
                paddingTop: 20,
              }}
            >
              Status
              <br />
              <span style={{ fontWeight: 500, marginTop: 5, color: "green" }}>
                Sent Successfully
              </span>
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography
              style={{
                padding: 7,
                fontSize: 10,
                fontWeight: "bold",
                paddingTop: 20,
              }}
            >
              Coupon
              <br />
              {discount}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>{imageValue}</Typography>
          </Grid>
          {/* <Grid item xs={12} style={{ marginTop: "7px" }}>
            <Paper className={classes.box3}>
              <Typography
                style={{
                  fontSize: 6,
                  display: "flex",
                  alignContent: "flex-start",
                  fontWeight: "600",
                  borderBottom: "0.1px dotted gray",
                  margin: 5,
                  marginTop: 5,
                }}
              >
                This is your estimated price.
                <br />
                The pharmacy will provide exact pricing.
              </Typography>
              <Grid
                container
                spacing={0}
                style={{ fontSize: 7, margin: 5, fontWeight: "Bold" }}
              >
                <Grid item xs={3}>
                  Member ID
                </Grid>
                <Grid item xs={3}>
                  Group
                </Grid>
                <Grid item xs={3}>
                  Bin
                </Grid>
                <Grid item xs={3}>
                  PCN
                </Grid>
              </Grid>
              <Grid
                container
                spacing={0}
                style={{
                  fontSize: 7,
                  marginLeft: 5,
                  marginTop: -4,
                  paddingTop: 0,
                  fontWeight: "Bold",
                }}
              >
                <Grid item xs={3}>
                  KH391737
                </Grid>
                <Grid item xs={3}>
                  DR75
                </Grid>
                <Grid item xs={3}>
                  015843
                </Grid>
                <Grid item xs={3}>
                  GDC
                </Grid>
              </Grid>
            </Paper>

            <Paper className={classes.box2}>
              <Typography
                style={{ fontSize: 7, color: "white", paddingTop: 13 }}
              >
                Discounted price with this coupon
              </Typography>
              <Grid container spacing={0}>
                <Grid item xs={6}>
                  <Typography
                    style={{
                      fontSize: 25,
                      fontWeight: "Bold",
                      color: "white",
                      Display: "Flex",
                      marginLeft: 20,
                    }}
                  >
                    ${valuem.price}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    style={{
                      fontSize: 8,
                      paddingTop: 9,
                      paddingLeft: 4,
                      margin: 8,
                      fontWeight: "Bold",
                      color: "white",
                    }}
                  >
                    at ShopRite
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
            <Paper className={classes.box1}>
              <Typography
                style={{
                  fontSize: 15,
                  marginTop: 10,
                  fontWeight: "Bold",
                }}
              >
                {valuem.medicationName}
              </Typography>
              <Typography
                style={{
                  fontSize: 8,
                  margin: 0,
                  fontWeight: "500",
                }}
              >
                {valuem.amount}
              </Typography>
            </Paper>
          </Grid> */}
        </Grid>
      </React.Fragment>
    );
  };

  restoreRows();

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <Grid container spacing={0}>
        <Grid
          item
          xs={12}
          style={{
            borderBottom: ".5px solid #d8d6d6",
            paddingTop: 20,
            paddingLeft: 36,
          }}
        >
          <Typography
            style={{
              color: "#4678ED",
              fontWeight: 570,
              marginTop: "0px",
              fontSize: "15px",
              marginBottom: "12px",
            }}
          >
            Prescription Confirmation{" "}
            <span
              style={{
                fontWeight: "bolder",
                color: "black",
                float: "right",
                paddingRight: "30px",
              }}
            ></span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: 0,
            marginBottom: 15,
          }}
        >
          <Typography style={{ padding: 10, fontSize: 11.5, fontWeight: 550 }}>
            Medication samples and coupons delivered right to your office.{" "}
            <span style={{ color: "#0389fb" }}>Free. Easy. Fast.</span>
          </Typography>

          <Typography
            style={{
              fontSize: 9.5,
              fontWeight: 2,
              paddingLeft: 10,
              marginTop: -10,
            }}
          >
            Request multiple products from a variety of suppliers, prescription
            saving cards, and get access to vouchers.
            <br /> Want to see the samples available to you? Find out now!
          </Typography>
          <Button
            className={classes.sample}
            style={{
              backgroundImage:
                "linear-gradient(315deg, #7f7f7f 0%, #9e9e9e 74%)",
              color: "white",
            }}
          >
            Learn more at sample center
          </Button>
        </Grid>
        <Grid
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: -10,
            marginBottom: 15,
          }}
        >
          <Grid item xs={4}>
            <Typography
              style={{
                padding: 10,
                fontSize: 10,
                fontWeight: "bold",
                paddingTopt: 20,
              }}
            >
              Pick Up Location
              <br />
              <span style={{ fontWeight: 10, marginTop: 5 }}>
                Phone: 703-205-7034
                <br />
                Fax: 703-205-7035
              </span>
            </Typography>
          </Grid>
          <Grid item xs={7}>
            <Typography
              style={{
                padding: 10,
                fontSize: 10,
                fontWeight: "bold",
                paddingLeft: 20,
              }}
            >
              VA Pharmacy 10.6MU
              <br />
              <span style={{ fontWeight: 10, marginTop: 5 }}>
                7723 Jefferson Davis Highway
                <br />
                Arlington, VA 22201
              </span>
            </Typography>
          </Grid>
        </Grid>
        
        {rowsState.map((name) => name)}
        <Grid item xs={12}>
          <Button
            className={classes.Button2}
            style={{
              backgroundImage:
                "linear-gradient(315deg, #7f7f7f 0%, #9e9e9e 74%)",
              color: "white",
              fontWeight: 600,
            }}
            onClick={handleCloseParentInfo}
          >
            Send
          </Button>
          <Button
            className={classes.Button1}
            style={{
              backgroundImage:
                "linear-gradient(315deg, #7f7f7f 0%, #9e9e9e 74%)",
              color: "white",
              fontWeight: 600,
            }}
          >
            Print Summary
          </Button>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div>
      <Button
        height="fit-content"
        borderRadius="20px"
        onClick={handleOpen}
        style={{
          padding:"8px 25px",
          marginTop: 0,
          fontSize: "16px",
          marginLeft: "18px",
          backgroundImage: "none",
          backgroundColor: "#D0D2D3",
          color: "#606060",
          fontWeight: 600,
          fontFamily: "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
          textAlign: "center",
          float: "right",

        }}
      >
        Process Medications
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
      <br />
    </div>
  );
}
